import { TokenServiceService } from './../../../services/token-service.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IAuthenticationRequest } from '../models/authentication-request/authentication-request.model';

@Injectable({
  providedIn: 'root',
})
export class ThreeDsService {
  private URL_SERVER: string = environment.urlglobal_api;
  constructor(
    private http: HttpClient,
    private tokenService: TokenServiceService
  ) {}

  threeDsValidatorService(data: any): Promise<any> {
    return this.http
    .post<any>(
      `${this.URL_SERVER}/v4/3ds/validator`,
      data,
      this.getHttpTokenOptions()
      )
      .toPromise();
  }

  informationVersioning(data: any): Promise<any> {
    return this.http
      .post<any>(
        `${this.URL_SERVER}/v4/3ds/versioning`,
        data,
        this.getHttpTokenOptions()
      )
      .toPromise();
  }

  authenticationRequest(data: IAuthenticationRequest): Promise<any> {
    return this.http
      .post<any>(
        `${this.URL_SERVER}/v4/3ds/authentication`,
        data,
        this.getHttpTokenOptions()
      )
      .toPromise();
  }

  getUrlServer(): string {
    return this.URL_SERVER;
  }

  private getHttpTokenOptions(): any {
    const token = this.tokenService.getToken();
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
      }),
    };
  }
}
